export enum DomainExtension {
    COM = 'com',
    NET = 'net',
    ORG = 'org',
    SE = 'se',
    NO = 'no',
    FI = 'fi',
    DK = 'dk',
  }